import { Modal } from 'antd';
import { styled } from 'styled-components';

export const ModalWrapper = styled(Modal)`
  .ant-modal-header {
    padding: 20px 24px 0;
    border-bottom: none;
  }
  .ant-modal-body {
    padding: 0 24px 20px;
  }
`;
